import React, { Component } from 'react';
import StepZilla from 'react-stepzilla';
import '../App.css';
import 'react-stepzilla/src/css/main.css';

import Routing from './steps/Routing.jsx';
import Environment from './steps/Environment.jsx';
import SubBU from './steps/SubBU.jsx';
import ProductName from './steps/ProductName.jsx';
import Summary from './steps/Summary.jsx';
import ProxyEnv from './steps/ProxyEnv.jsx';

class CreateNewProxyHome extends Component {

	constructor(props) {
		super(props);
		this.state = {
			virtualPath: '/retirement/v1/sample',
			targetPath: '/retirement/v1/sample',
			environment: 'internal',
			buildEnvironment: [],
			//used for naming the prefix
			subBU:'WSRS',
			//used to determine product name + the owning AD group, see comment below
			gitURL:'',
			//this is only used if a) the Product does not exist, or b) the Product currently has no owning AD group assigned.
			adGroup:'',
			productName:'',
			isNewProduct: false
		};
	}

	getStore = () => {
		return this.state;
	}

	updateStore = (update) => {
		this.setState(update);
	}

	render() {
		const createNewProxySteps = [
			{name: 'Deployment Environment', component: <Environment getStore={this.getStore} updateStore={this.updateStore}/>},
			{name: 'Build Environment', component: <ProxyEnv getStore={this.getStore} updateStore={this.updateStore}/>},
			{name: 'Routing', component: <Routing getStore={this.getStore} updateStore={this.updateStore}/>},
			{name: 'SubBU', component: <SubBU getStore={this.getStore} updateStore={this.updateStore}/>},
			{name: 'Product Name', component: <ProductName getStore={this.getStore} updateStore={this.updateStore}/>},
			{name: 'Summary', component: <Summary getStore={this.getStore}/>}
		];
		return (
			<div className="container">
				<h1>Create New Proxy</h1>
				<hr/>
				<div className='step-progress'>
					<StepZilla
						nextButtonCls="btn btn-next btn-primary util-margin-top-50"
						backButtonCls="btn btn-prev btn-link util-margin-top-50"
						steps={createNewProxySteps}
					/>
				</div>
			</div>
		);
	}
}

export default CreateNewProxyHome;
